<ul class="list-group">
  @for (prescriber of prescribers; track prescriber) {
    <li
      (click)="onPrescriberClick(prescriber)"
      (keydown.enter)="onPrescriberClick(prescriber)"
      tabindex="0"
      class="list-group-item list-group-item-action justify-content-between align-items-center"
      >
      <div>
        <strong>{{ prescriber.provider | providerNameWithNpi }} </strong>
      </div>
      <div>
        <app-specialty-badges [specialties]="prescriber.provider.specialties" />
      </div>
    </li>
  }
</ul>
